module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    attrs: {
      "id": "الخاتم-العجيب"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "right",
      "font-family": "Sakkal Majalla"
    }
  }, [_c('strong', [_c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "text-align": "center",
      "font-family": "Sakkal Majalla"
    }
  }, [_c('strong', [_vm._v("الإهــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــداء")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-family": "Sakkal Majalla"
    }
  }, [_c('strong', [_vm._v("إلى أبنائي الثلاثة:")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-family": "Sakkal Majalla"
    }
  }, [_c('strong', [_vm._v("أسعد، أسيل، إيناس؛")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-family": "Sakkal Majalla"
    }
  }, [_c('strong', [_vm._v("الذين ملأوا حياتي حباً وسعادة")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbda0262","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0003.vue
// module id = 72
// module chunks = 0